import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff'; // Using a relevant icon
import ContentPasteSearchRoundedIcon from '@mui/icons-material/ContentPasteSearchRounded';

const NoItemsFound = ({ title = "No Items Found" }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'secondary.faint',
        padding: "1rem 0",
        border: '1px dashed',
        borderColor: 'secondary.light',
        borderRadius: '5px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1, // Adjust as needed
        textAlign: 'center',
        gap: "1rem", // Space between icon and text
        width: '100%',
      }}
    >
      <ContentPasteSearchRoundedIcon
        sx={{
          fontSize: 45, // Size of the icon
          color: 'basic.main', // MUI theme color
        }}
      />
      <Typography
        variant="h6"
        component="h2"
        sx={{
          color: 'basic.main',
          fontWeight: "500"
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default NoItemsFound;